import { user } from "../slices/user";
import { auth } from "../slices/auth";

export const root = {
  user,
  auth
};
